/**
 * localityNameUr — the single Urdu-name registry for this estate's Lahore
 * localities, shared by every surface that renders a locality as data (sensor
 * detail, map popups, locality pages) rather than as a translated UI label.
 *
 * Spellings verified against Urdu Wikipedia entries for each neighbourhood.
 * "Township" keeps its common form — Urdu Wikipedia notes the area was
 * officially renamed "Qaid-e-Azam Town", but it is still universally written
 * ٹاؤن شپ on signage and in local usage, so that is what ships here.
 */
const LOCALITY_NAME_UR: Record<string, string> = {
  "Johar Town": "جوہر ٹاؤن",
  Samanabad: "سمن آباد",
  "Model Town": "ماڈل ٹاؤن",
  Gulberg: "گلبرگ",
  "Allama Iqbal Town": "علامہ اقبال ٹاؤن",
  Township: "ٹاؤن شپ",
  "Faisal Town": "فیصل ٹاؤن",
  "Garden Town": "گارڈن ٹاؤن",
  // WASA `sub_division` aliases (configs/wasa-demo-8localities.yaml) — same
  // place, a differently-cased or shortened spelling of the locality name.
  "Johar town": "جوہر ٹاؤن",
  "Iqbal Town": "علامہ اقبال ٹاؤن",
};

/** Locality display name for the active language; falls back to the English name when unmapped. */
export function localityLabel(name: string | null | undefined, lang: string): string | null {
  if (!name) return name ?? null;
  if (lang !== "ur") return name;
  return LOCALITY_NAME_UR[name] ?? name;
}
